<template>
  <div class="all-style-bgc">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoreportInternet">清风论坛></span>
        <span @click="GoreportEvaluation">亦廉课堂></span>
        <span class="red">正文</span>
      </div>
      <!--正文内容-->
      <div class="text">
        <h1>拓展教育方式 确保“一案一教育”入脑入心</h1>
                <h2><span class="mg-16">来源：新华社</span>|<span class="mg-16">发布时间：2020-03-30&nbsp;13:30</span></h2>

        <h3>“要以人防系统腐败问题为专项治理整改为契机，结合此次案件，拓展“一案一教育”开展方式，用身边事教育身边人，做好教育引导后半篇文章。”</h3>
        <h3>近日，派驻市人大机关纪检监察组督促指导市民防办结合人防系统腐败问题专项治理工作开展以来，给予党政纪处分典型案例，以“廉政测试+体会交流+廉政党课”的方式召开了“一案一教育”警示教育大会，强化警示教育的感染力和说服力。</h3>
        <h3>据悉，市民防办第一时间召开了“一案一教育”工作警示教育大会，会议现场组织全体党员、公职人员进行了党风廉政知识测试，通报了市民防办违纪违法受到党纪政纪处理人员案情并宣布处分决定，宣读了违纪违法人员忏悔书，部分同志结合自身岗位谈了自身的心得体会。</h3>
        <h3>市民防办党组织负责人在讲授廉政党课时要求，全体党员干部、公职人员要深刻领会“一案一教育”警示意义，准确把握当前反腐倡廉的新形势、新要求，时刻绷紧廉洁自律这根弦，坚持做到自重、自省、自警、自励，切实增强拒腐防变的自觉性和坚定性。</h3>
        <h3>该纪检监察组负责人表示，将持续监督指导市民防办开展好“一案一教育”工作，将继续拓展教育方式，“量身定制”教育方案，突出针对性和实效性，发挥警示教育的深远作用。（刘孟丽  闵翼飞）</h3>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      PicBannertest1: require("../../../../assets/image/bannertest1.jpg"),
      PicBannertest2: require("../../../../assets/image/bannertest2.jpg")
    };
  },
  methods: {
    GoreportInternet() {
      this.$router.push("/forum");
    },
    GoreportEvaluation() {
      this.$router.push({ name: "forumClassroom" });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
/*副导航兰*/
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
/*问卷调查正文*/
.text {
  background-color: white;
  padding: 44px 60px 121px 60px;
  margin: 0 auto;
}
.text h1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  text-align: center;
}
.text h2 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 44px;
  text-align: center;
   padding-bottom: 14px;
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 15px;
}
.text h3 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  text-indent: 2em;
  margin-bottom: 30px;
}
/*静态页面样式 */
.PIC-BOX {
  display: flex;
  justify-content: center;
}
img{
  margin: 20px 0px;
}
.mg-16{
  margin: 0px 16px;
}
</style>